import React from "react";
import { motion } from "framer-motion";

const zones = [
  { range: "0 – 35", label: "Probabilité virale", color: "#5BC4D1", side: "left" },
  { range: "35 – 65", label: "Équivoque", color: "#94A3B8", side: "center" },
  { range: "65 – 100", label: "Probabilité bactérienne", color: "#F59E0B", side: "right" },
];

const ScoreScale = () => {
  return (
    <section
      data-testid="score-scale-section"
      className="relative py-24 md:py-32 bg-[#0A1128]/60"
    >
      <div className="max-w-5xl mx-auto px-6 md:px-8">
        <motion.div
          className="text-center mb-14"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8 }}
        >
          <div className="text-xs uppercase tracking-[0.2em] text-[#5BC4D1] font-medium mb-4">
            Interprétation du score MeMed BV®
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-light leading-tight tracking-tight">
            Un score, <span className="font-semibold">une décision claire.</span>
          </h2>
          <p className="mt-5 text-slate-300 leading-relaxed max-w-2xl mx-auto">
            Chaque résultat est exprimé sur une échelle continue de 0 à 100,
            traduisant la probabilité d&apos;une infection bactérienne.
          </p>
        </motion.div>

        <motion.div
          className="relative"
          initial={{ opacity: 0, scaleX: 0.5 }}
          whileInView={{ opacity: 1, scaleX: 1 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
        >
          {/* Scale bar */}
          <div className="relative h-3 rounded-full overflow-hidden border border-white/10"
            style={{
              background:
                "linear-gradient(90deg, #5BC4D1 0%, #5BC4D1 30%, #475569 35%, #475569 60%, #F59E0B 70%, #F59E0B 100%)",
            }}
          />

          {/* Tick marks */}
          <div className="relative mt-2 grid grid-cols-5 text-[10px] text-slate-500 tracking-wider">
            <span>0</span>
            <span className="text-center">25</span>
            <span className="text-center">50</span>
            <span className="text-center">75</span>
            <span className="text-right">100</span>
          </div>

          {/* Zones */}
          <div className="mt-10 grid md:grid-cols-3 gap-4">
            {zones.map((z, i) => (
              <motion.div
                key={z.label}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ delay: i * 0.12, duration: 0.7 }}
                data-testid={`score-zone-${i}`}
                className="bg-[#0E1530] border border-white/10 rounded-2xl p-6"
              >
                <div
                  className="h-2 w-12 rounded-full mb-4"
                  style={{ backgroundColor: z.color }}
                />
                <div className="text-xs uppercase tracking-wider text-slate-500">
                  Score
                </div>
                <div className="font-display text-2xl font-medium text-white mt-1">
                  {z.range}
                </div>
                <div className="text-sm mt-2" style={{ color: z.color }}>
                  {z.label}
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ScoreScale;
